export enum ComplaintMaterialStatus {
  COMPLAINT_RECEIVED = "COMPLAINT_RECEIVED",
  RESOLVED = "RESOLVED",
  DISPATCHED = "DISPATCHED",
  HANDED_BACK_TO_CLIENT = "HANDED_BACK_TO_CLIENT",
  CANCELLED = "CANCELLED",
}

export const ComplaintMaterialStatusLabel: Record<ComplaintMaterialStatus, string> = {
  [ComplaintMaterialStatus.COMPLAINT_RECEIVED]: "Complaint Received",
  [ComplaintMaterialStatus.RESOLVED]: "Resolved",
  [ComplaintMaterialStatus.DISPATCHED]: "Dispatched",
  [ComplaintMaterialStatus.HANDED_BACK_TO_CLIENT]: "Handed Back to Client",
  [ComplaintMaterialStatus.CANCELLED]: "Cancelled",
};

/** StatusBadge color map. */
export const complaintMaterialStatusMap: Record<string, { label: string; color: string }> = {
  [ComplaintMaterialStatus.COMPLAINT_RECEIVED]: { label: "Complaint Received", color: "warning" },
  [ComplaintMaterialStatus.RESOLVED]: { label: "Resolved", color: "primary" },
  [ComplaintMaterialStatus.DISPATCHED]: { label: "Dispatched", color: "secondary" },
  [ComplaintMaterialStatus.HANDED_BACK_TO_CLIENT]: { label: "Handed Back to Client", color: "success" },
  [ComplaintMaterialStatus.CANCELLED]: { label: "Cancelled", color: "danger" },
};

/**
 * There's no edit lock in this module (it's a date register, not a
 * pipeline) — this only gates the one surviving action, Cancel, which the
 * API rejects once the record is already CANCELLED or already
 * HANDED_BACK_TO_CLIENT.
 */
export function isComplaintMaterialCancelBlocked(
  status: ComplaintMaterialStatus | string,
): boolean {
  return (
    status === ComplaintMaterialStatus.HANDED_BACK_TO_CLIENT ||
    status === ComplaintMaterialStatus.CANCELLED
  );
}

export enum ComplaintMaterialSelectionType {
  MATERIAL = "MATERIAL",
  OTHER = "OTHER",
}

export const ComplaintMaterialSelectionTypeLabel: Record<ComplaintMaterialSelectionType, string> = {
  [ComplaintMaterialSelectionType.MATERIAL]: "Material from catalog",
  [ComplaintMaterialSelectionType.OTHER]: "Client-supplied item (not in catalog)",
};

export enum ComplaintMaterialWarrantyStatus {
  IN_WARRANTY = "IN_WARRANTY",
  OUT_OF_WARRANTY = "OUT_OF_WARRANTY",
}

export const ComplaintMaterialWarrantyStatusLabel: Record<ComplaintMaterialWarrantyStatus, string> = {
  [ComplaintMaterialWarrantyStatus.IN_WARRANTY]: "In warranty",
  [ComplaintMaterialWarrantyStatus.OUT_OF_WARRANTY]: "Out of warranty",
};
